import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Card, CardHeader } from "src/components/commons/Card";
import { MATCH_ACTION, STATUS_MAP } from "src/helpers/constants";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import { SchedulesList } from "../commons/SchedulesList";
import { Chip } from "../commons/Chip";
import { SuccessfulMatches } from "./SuccessfulMatches";
import Table from "src/components/commons/Table/Table";
import StatusChip from '../commons/StatusChip';
import { getFounderMatches, getVendorWithUserAnswersForAdmin, updateFounderVendorMatchStatus } from 'src/api/vendorServices';
import { formatPhone } from 'src/helpers';
import { Box } from "@mui/material";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DashboardDetails from './DashboardDetails';
import { getMatchActionButtons } from 'src/helpers/matchActions.jsx';
// import { PendingMatches } from "./PendingMatches";

export function FounderDashboard({ allCampaigns = [] }) {
	const { authUser } = useSelector(({ auth }) => auth);
	const [matches, setMatches] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [viewOpen, setViewOpen] = useState(false);
	const [viewDetails, setViewDetails] = useState(null);

	useEffect(() => {
		async function fetchMatches() {
			try {
				setLoading(true);
				setError(false);
				const matchesArr = await getFounderMatches(authUser.id, { page: page + 1, limit: rowsPerPage });
				setMatches(matchesArr || []);
				setTotalCount((matchesArr && matchesArr.length > 0 && matchesArr[0].total_count) || 0);
			} catch (e) {
				setError(true);
			} finally {
				setLoading(false);
			}
		}
		if (authUser?.id) fetchMatches();
	}, [authUser?.id, page, rowsPerPage]);

	const handleViewVendor = async (row) => {
		const vendorServiceId = row.vendor_service_id || row.vendor_service || row.id;
		console.log(vendorServiceId);
		console.log(row);
		try {
			const details = await getVendorWithUserAnswersForAdmin(vendorServiceId);
			console.log(details);
			setViewDetails(details);
			setViewOpen(true);
		} catch (e) {
			setViewDetails(null);
			setViewOpen(false);
		}
	};

	const handleAccept = async (row) => {
		try {
			const updatedMatch = await updateFounderVendorMatchStatus(row.id, { status: 'active' });
			// Update the local state immediately
			setMatches(prevMatches => 
				prevMatches.map(match => 
					match.id === row.id 
						? { ...match, status: 'active' }
						: match
				)
			);
		} catch (e) {
			console.error('Error accepting match:', e);
		}
	};

	const handleDecline = async (row) => {
		try {
			const updatedMatch = await updateFounderVendorMatchStatus(row.id, { 
				status: 'declined',
				call_status: 'declined'
			});
			// Update the local state immediately
			setMatches(prevMatches => 
				prevMatches.map(match => 
					match.id === row.id 
						? { ...match, status: 'declined', call_status: 'declined' }
						: match
				)
			);
		} catch (e) {
			console.error('Error declining match:', e);
		}
	};

	return (
		<div>
			<div className="grid grid-cols-1 gap-4">
				<div className="grid grid-cols-1 md:grid-cols-3 gap-4 min-h-[250px]">
					<Card>
						<CardHeader>
							<span className="text-lg">Round</span>
						</CardHeader>
						<div className="text-slate-400 flex justify-center items-center h-full">No Data Found</div>
					</Card>
					<Card>
						<CardHeader>
							<span className="text-lg">Valuation</span>
						</CardHeader>
						<div className="text-slate-400 flex justify-center items-center h-full">No Data Found</div>
					</Card>
					<Card>
						<CardHeader>
							<span className="text-lg">Schedules</span>
						</CardHeader>
						<div className="text-slate-400 flex justify-center items-center h-full">No Data Found</div>
						{/* <SchedulesList acceptedMatches={matches} /> */}
					</Card>
				</div>
				<Card>
					<div className="p-4 rounded-t-md border border-b-gray-200 flex justify-between items-center">
						<h2 className="text-lg">Matches</h2>
						<span className="text-primary cursor-pointer">
						<a href="/founder-matches">See all</a>
					</span>
					</div>
					<Table
						columns={[
							{ header: 'Offered Service', accessor: 'offered_service', align: 'left' },
							{ 
								header: 'Match Status', 
								accessor: 'status', 
								align: 'center', 
								render: (_, row) => <StatusChip status={row.status} />
							},
							{ 
								header: 'Call Status', 
								accessor: 'call_status', 
								align: 'center', 
								render: (_, row) => <StatusChip status={row.call_status} />
							},
							{ header: 'Vendor Name', accessor: 'vendor_name', align: 'center' },
							{ header: 'Vendor Email', accessor: 'vendor_email', align: 'center' },
							{ header: 'Action', accessor: 'action', align: 'center', render: (_, row) => 
								getMatchActionButtons({
									row,
									onView: handleViewVendor,
									onAccept: handleAccept,
									onDecline: handleDecline
								})
							},
						]}
						data={matches}
						loading={loading}
						error={error}
						page={page}
						rowsPerPage={rowsPerPage}
						totalCount={totalCount}
						onPageChange={(_, newPage) => setPage(newPage)}
						onRowsPerPageChange={e => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
						stickyHeader
						className="border-0"
						emptyStateMessage="There are no pending matches at the moment"
					/>
				</Card>
				{/* <SuccessfulMatches acceptedMatches={matches} currentRole={authUser.role} /> */}
				{/* <PendingMatches pendingMatches={pendingMatches} currentRole={currentRole} /> */}
				<hr className="my-4" />
				<Card>
					<CardHeader>
						<span className="text-xl">All Campaigns</span>
					</CardHeader>
					<Table
						columns={[
							{ header: 'Name', accessor: 'name', align: 'left' },
							{ header: 'Status', accessor: 'status', align: 'center', render: (value) => <StatusChip status={value} /> },
							{ header: 'Actions', accessor: 'actions', align: 'right', render: (_, row) => (
								<Button
									variant="contained"
									style={{ backgroundColor: '#3096F5', color: '#fff' }}
									href={`/campaign/${row.id}/details`}
								>
									View
								</Button>
							) },
						]}
						data={allCampaigns.data}
						loading={false}
						error={false}
						page={0}
						rowsPerPage={allCampaigns.data.length}
						totalCount={allCampaigns.data.length}
						onPageChange={() => {}}
						onRowsPerPageChange={() => {}}
						stickyHeader
						className="border-0"
						emptyStateMessage="No campaigns found."
					/>
				</Card>
			</div>
			{/* Vendor Details Modal */}
			<Dialog open={viewOpen} onClose={() => setViewOpen(false)} maxWidth="sm" fullWidth>
				<DialogTitle>Vendor Details</DialogTitle>
				<DialogContent>
					{viewDetails ? (
						<DashboardDetails 
							details={viewDetails} 
							userType="FOUNDER" 
						/>
					) : (
						<div>No details found.</div>
					)}
				</DialogContent>
			</Dialog>
		</div>
	);
}
